<div class="flex flex-col gap-3.5">
	<div class="grid grid-cols-[28px_1fr_28px] items-center gap-2.5">
		<button
			type="button"
			class="arrow w-7 h-7 rounded-full border border-[#e3e8f0] bg-white text-[#0e1438] inline-flex items-center justify-center transition-colors transition-transform duration-150 hover:bg-[#cff5d5] active:scale-95 disabled:opacity-35 disabled:cursor-not-allowed"
			(click)="prev()"
			[disabled]="!canPrev"
			[attr.aria-label]="'VIEWS.USER_BOARD.COCKPIT.PREV' | translate">
			<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M9 2L4 7l5 5" />
			</svg>
		</button>

		<div class="hist-card rounded-2xl px-5 py-4 transition-colors transition-opacity duration-200" *ngIf="current as p"
			[class.is-period-active]="p.active"
			[class.is-expired]="!p.active">
			<div class="font-bold text-[#0e1438] text-[13.5px] mb-2 tabular-nums">
				{{ p.from | date : 'dd.MM.yyyy' }} — {{ p.to | date : 'dd.MM.yyyy' }}
			</div>
			<div class="hist-stats flex flex-col gap-1 max-h-[88px] overflow-y-auto pr-1">
				<div *ngFor="let s of p.stats" class="text-[15px] text-[#0e1438] font-medium flex items-baseline gap-1.5">
					<b class="font-bold">
						<ng-container *ngIf="s.unlimited; else valueTpl">∞</ng-container>
						<ng-template #valueTpl>{{ s.value }}</ng-template>
					</b>
					<span>
						<ng-container *ngIf="s.label; else translatedStat">{{ s.label }}</ng-container>
						<ng-template #translatedStat>{{ s.labelKey ?? '' | translate }}</ng-template>
					</span>
				</div>
			</div>
		</div>

		<button
			type="button"
			class="arrow w-7 h-7 rounded-full border border-[#e3e8f0] bg-white text-[#0e1438] inline-flex items-center justify-center transition-colors transition-transform duration-150 hover:bg-[#cff5d5] active:scale-95 disabled:opacity-35 disabled:cursor-not-allowed"
			(click)="next()"
			[disabled]="!canNext"
			[attr.aria-label]="'VIEWS.USER_BOARD.COCKPIT.NEXT' | translate">
			<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M5 2l5 5-5 5" />
			</svg>
		</button>
	</div>

	<div class="flex justify-center" *ngIf="current as p">
		<div class="status-tag inline-flex items-center px-7 py-2 rounded-full font-bold text-[13.5px]"
			[class.is-period-active]="p.active"
			[class.is-expired]="!p.active">
			{{
				(p.active
					? 'VIEWS.USER_BOARD.COCKPIT.ACTIVE'
					: 'VIEWS.USER_BOARD.COCKPIT.EXPIRED'
				) | translate
			}}
		</div>
	</div>
</div>
